import Box from "ds/components/Box";

import { WorkerUsageData } from "../types";
import UsageWorkersMetricCard from "./Card";
import { getWorkerUsageCards } from "./utils";

type UsageWorkersMetricCardsProps = {
  usage: WorkerUsageData;
};

const UsageWorkersMetricCards = ({ usage }: UsageWorkersMetricCardsProps) => (
  <Box direction="row" wrap gap="x-large" fullWidth>
    {getWorkerUsageCards(usage).map((card) => (
      <UsageWorkersMetricCard key={card.label} {...card} />
    ))}
  </Box>
);

export default UsageWorkersMetricCards;
